import { useFeatureGates } from '@office-start/feature-gates-service';
import { RecommendedControlSkeleton } from '@office-start/recommended-control';
import React from 'react';
var RecommendedFallbackComponent = function () {
    var _a, _b, _c;
    var featureGates = useFeatureGates().data;
    var loadingUiEnabled = (_c = (_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _a === void 0 ? void 0 : _a.loadingUiGates) === null || _b === void 0 ? void 0 : _b.loadingUiEnabled) !== null && _c !== void 0 ? _c : false;
    return loadingUiEnabled ? React.createElement(RecommendedControlSkeleton, null) : null;
};
export var RecommendedComponentFallback = {
    node: React.createElement(RecommendedFallbackComponent, null),
};
//# sourceMappingURL=RecommendedComponentFallback.js.map